export default __webpack_public_path__ + "static/media/cancel.da5c4222.svg";